var cmsSidebar = vueIfExists({
  el: '#cms-sidebar',
  data: {
      page: dataLayer[0].custompage
  },
  mounted: function() {

      switch (this.page) {
          case 'cms-aboutus':
               this.$el.querySelector('.cmsaboutus').classList.add('active');
              break;
          case 'cms-faq':
               this.$el.querySelector('.cmsfaq').classList.add('active');
               break;
          case 'cms-customerservice':
               this.$el.querySelector('.cmscustomerservice').classList.add('active');
               break;
               case 'cms-offices':
               this.$el.querySelector('.cmsoffices').classList.add('active');
               break;
      }


  }
});
